import { ELOQUA_COOKIE } from 'shared/constants/cookies'

const ELOQUA_GATE = 'eloqua_cookie_id_enabled'

const EloquaIdentityProvider = {
  isEnabled: (gates: Record<string, any> = {})=>{
    return gates[ELOQUA_GATE]
  },
  identify: (cookies: Record<string, any> = {}) => {
    return cookies[ELOQUA_COOKIE]
  },
  getIntegrationContext: (cookies: Record<string, any> = {}) => {
    return !!cookies[ELOQUA_COOKIE]
      ? {
          eloqua: { cookie: cookies[ELOQUA_COOKIE] }
        }
      : {}
  }
}

export default EloquaIdentityProvider
